import React from 'react';

const AxiosContext = React.createContext({
  instance: null,
});

export default AxiosContext;
